import { createTranslationInterpolator, } from "../interpolation/createTranslationInterpolator";
/**
 * Create a translator function
 * @param options
 * @returns
 */
export function createTranslatorWithInterpolation(options) {
    const interpolator = createTranslationInterpolator(options);
    const { translator, translations } = options;
    return (translationKey, fallbackTranslation, interpolationVariables) => {
        const variables = interpolator(interpolationVariables);
        return translator(translationKey, fallbackTranslation, Object.assign({ variables }, translations));
    };
}
//# sourceMappingURL=createTranslatorWithInterpolation.js.map